<template>
  <div>
    <div class="buttom">
      <div class="typeNav">
        <div>
          <button class="blueButton" @click="toMapMode" style="    margin-left: 0px;">地图<br>模式</button>
          <button class="blueButton" @click="updateImage">行程<br>图片</button>
          <button class="blueButton" @click="exportWord">报价<br>分享</button>
          <button class="blueButton" @click="toInquiryPage">询价<br>回复</button>
        </div>
        <div>
          <div class="typeList">
            <div @click="onlySeeOneType(chooseStockTypes.length === stockTypes.length ? '' : 'all')"
              :class="chooseStockTypes.length === stockTypes.length ? 'checkedLi' : ''">全部</div>
            <div v-for="(name, ind) in stockTypes" :key="ind"
              :class="chooseStockTypes.indexOf(name.state) != -1 ? 'checkedLi' : ''"
              @click="onlySeeOneType(name.state)">
              {{ name.typeNameSimple }}</div>
          </div>
          <div class="priceDiv">
            <el-input v-model="searchProductName" placeholder="请输入你要搜索的名称" style="width: 2rem;" size="mini"
              @blur="searchProduct()" />
            <el-select v-if="hasOrderNumber" v-model="orderStatus" placeholder="下拉菜单" @change="searchProduct()"
              style="width: 0.8rem;margin-left: 0.05rem;" size="mini">
              <el-option label="全部" value=""></el-option>
              <el-option label="待支付" value="待支付"></el-option>
              <el-option label="待确认" value="待确认"></el-option>
              <el-option label="待出行" value="待出行"></el-option>
              <el-option label="待点评" value="待点评"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="planDayDiv" v-if="budgetList.length > 0">
        <trip-left-day :chenckBudget="chenckBudget" ref="tripLeftDay"></trip-left-day>
        <div class="right">
          <trip-left-budget :checkBudget="chenckBudget" :chooseStockTypes="chooseStockTypes"
            :showCostPrice="showCostPrice" :budgetList="budgetList" :planProductShowStatus="planProductShowStatus"
            :allStockTypes="stockTypes" :planDetail="planDetail"></trip-left-budget>
        </div>
        <div class="rightButton">
          <span class="circle circle1" @click="zhiding()">
            <svg-icon :iconClass="'zhiding'" style="width:0.15rem"></svg-icon>
          </span>
          <span class="circle" @click="planProductShowStatus = !planProductShowStatus">{{ planProductShowStatus ? '简' :
            '详' }}</span>
          <span class="circle circle1" @click="addPlan()">
            <svg-icon :iconClass="'save'" style="width:0.15rem"></svg-icon>
          </span>
          <span class="circle" @click="openProductMoveDialog"> <i class="el-icon-sort"></i></span>
          <span class="circle" @click="changePlanTime"> <svg-icon :systemColor="'#e64a19'" :iconClass="'clock'"
              style="width: 0.15rem;height: 0.15rem;"></svg-icon></span>
        </div>
      </div>
    </div>
    <upload-image ref="uploadImage"></upload-image>
    <createPreOrder ref="orderPre"></createPreOrder>
    <budget-detail-dialog ref="budgetDetail" :chenckBudget="chenckBudget"
      :planDetail="planDetail"></budget-detail-dialog>
    <product-move ref="productMove"></product-move>
    <change-plan-time-dialog ref="changePlanTime" :checkBudgetDetail="chenckBudget"></change-plan-time-dialog>
    <export-plan ref="exportPlan" :showPlanSendButton="hasCustomerName" :checkBudget="chenckBudget"></export-plan>
  </div>
</template>

<script>
import TripLeftBudget from './tripLeftBudget.vue'
import TripLeftDay from './tripLeftDay.vue'
import uploadImage from "./dialog/uploadImage.vue"
import createPreOrder from '@/views/plan/leftMoudle/dialog/createPreOrder'
import BudgetDetailDialog from './dialog/budgetDetailDialog.vue'
import ProductMove from './dialog/productMove.vue'
import changePlanTimeDialog from './dialog/changePlanTimeDialog.vue'
import { stockTypeList } from '@/assets/utils/commonData'
import PlanApi from '@/components/Api/PlanApi.js'
import { getPlanInfo } from '../js/function'
import exportPlan from '@/views/plan/leftMoudle/dialog/exportPlan'
export default {
  components: { exportPlan, TripLeftBudget, TripLeftDay, uploadImage, createPreOrder, BudgetDetailDialog, ProductMove, changePlanTimeDialog },
  methods: {
    searchProduct() {
      if (this.searchProductName != '' || this.orderStatus != '') {
        if(this.searchProductName!=''){
          this.chenckBudget.planDayList.forEach(ee => {
            ee.budgetDetails.forEach(eee => {
              if (eee.resourceNameCn.indexOf(this.searchProductName) != -1) {
                this.$set(eee, 'isShow', true)
              } else {
                eee.details.forEach(ddd => {
                  if (ddd.productName.indexOf(this.searchProductName) != -1) {
                    this.$set(ddd, 'isShow', true)
                  } else {
                    this.$set(ddd, 'isShow', false)
                  }
                })
                if (eee.details.filter(ddd => ddd.isShow).length == 0) {
                  this.$set(eee, 'isShow', false)
                }
              }
              eee.details.forEach(ddd => {
                if (ddd.productName.indexOf(this.searchProductName) != -1) {
                  this.$set(ddd, 'isShow', true)
                  this.$set(eee, 'isShow', true)
                } else {
                  this.$set(ddd, 'isShow', false)
                }
                if(this.orderStatus!=''){
                  if(ddd.orderStatus==this.orderStatus){
                    this.$set(ddd,'isShow',true)
                    this.$set(eee,'isShow',true)
                  }else{
                    this.$set(ddd,'isShow',false)
                  }
                }
              })
              
            })
          })
        }
        if(this.orderStatus!=''){
          this.chenckBudget.planDayList.forEach(ee => {
            ee.budgetDetails.forEach(eee => {
              eee.details.forEach(ddd => {
                  if(ddd.orderStatus==this.orderStatus){
                    this.$set(ddd,'isShow',true)
                  }else{
                    this.$set(ddd,'isShow',false)
                  }
              })
              if (eee.details.filter(ddd => ddd.isShow).length == 0) {
                this.$set(eee, 'isShow', false)
              }
            })
          })
        }
      } else {
        this.chenckBudget.planDayList.forEach(ee => {
          ee.budgetDetails.forEach(eee => {
            this.$set(eee, 'isShow', true)
            eee.details.forEach(ddd => {
              this.$set(ddd, 'isShow', true)
            })
          })
        })
      }
      this.countPrice('')
    },
    exportWord() {
      this.$refs.exportPlan.init(this.chenckBudget.id, this.chenckBudget.planId)
    },
    init(data, isOrder) {
      this.planDetail = data
      if (isOrder && this.chenckBudget.planDayList) {
        this.chenckBudget.planDayList.forEach(item => {
          this.$set(item, 'inputShowState', false)
        })
        this.$nextTick(() => {
          this.$Bus.$emit('checkPlanObj', this.chenckBudget.planDayList.find(e => e.planDay == this.$refs.tripLeftDay.checkPlanDay), this.chenckBudget)
        })
      }
    },
    toInquiryPage() {
      this.$store.commit('setCheckIndex', 1)
      this.$store.commit('setRightPopupIndex', 2)
      this.$Bus.$emit('toInquiryPage')
    },
    updateImage() {
      this.$refs.uploadImage.openDialog(this.chenckBudget)
    },
    addPlan() {
      new PlanApi('plan').saveBudgetMain({
        id: this.chenckBudget.id,
      }).then(res => {
        if (res.status == 200) {
          this.$message({ type: "success", message: "该方案版本已保存成功" })
          getPlanInfo(this.chenckBudget.planId, res.data)
        } else {
          this.$message({ type: "error", message: res.statusText })
        }
      })
    },
    toMapMode() {
      this.$router.push({ name: 'mapPlan', params: this.chenckBudget })
    },
    showPlanShare() {
      this.dialogVisible = true
    },
    onlySeeOneType(type) {// 根据接受的type显示列表项
      if (type === '') {
        this.chooseStockTypes = []
      } else if (type == 'all') {
        this.chooseStockTypes = []
        this.stockTypes.forEach((item, index) => {
          this.chooseStockTypes.push(item.state)
        })
      } else if (this.chooseStockTypes.indexOf(type) != -1) {
        this.chooseStockTypes.splice(this.chooseStockTypes.indexOf(type), 1)
      } else {
        this.chooseStockTypes.push(type);
      }
      this.countPrice('')
    },
    countPrice(type, data1) {
      this.immediateCost = 0
      this.immediateOffer = 0
      var createTime = 0
      var key = ''
      var flag = true
      if (this.chooseStockTypes.length != this.stockTypes.length && this.chooseStockTypes.length > 0) {
        flag = false
      }
      if (type == 'init') {
        this.stockTypes = []
        if (flag) {
          this.chooseStockTypes = []
        }
      }
      this.chenckBudget.planDayList.forEach(e => {
        e.budgetDetails.forEach(budget => {
          var totalPrice = 0
          var saleTotalPrice = 0
          var currency = ''
          if (type == 'init') {
            this.$set(budget, 'isShow', true)
            if (flag && this.chooseStockTypes.indexOf(budget.state) == -1 && budget.state != 11) {
              this.chooseStockTypes.push(budget.state)
            }
            if (this.stockTypes.map(e => e.state).indexOf(budget.state) == -1 && budget.state != 11) {
              this.stockTypes.push(this.stockTypeList.find(s => s.state === budget.state))
            }
          }
          budget.linkBudgets.forEach(ee => {
            ee.details.forEach(eee => {
              if (type == 'init') {
                totalPrice = totalPrice + (eee.stockPrice * eee.stockNumber * eee.rate)
              }
              if (this.chooseStockTypes.indexOf(budget.state) != -1) {
                this.immediateCost = this.immediateCost + (eee.stockPrice * eee.stockNumber * eee.rate)
              }
            })
          })
          budget.details.forEach(detail => {
            if (type == 'init') {
              this.$set(detail, 'isShow', true)
              if (budget.linkBudgets.length == 0) {
                totalPrice = totalPrice + (detail.stockPrice * detail.stockNumber)
                currency = detail.currency
              } else {
                currency = "¥"
              }
              saleTotalPrice = saleTotalPrice + (detail.ratio * detail.stockNumber)
              var stockDetail = {}
              if (detail.stockDetail && detail.stockDetail != '' && typeof detail.stockDetail !== "object") {
                stockDetail = JSON.parse(detail.stockDetail)
              }
              this.$set(detail, 'stockDetail', stockDetail)
            }
            if (this.chooseStockTypes.indexOf(budget.state) != -1 && budget.isShow) {
              if (budget.linkBudgets.length == 0) {
                this.immediateCost = this.immediateCost + (detail.stockPrice * detail.stockNumber * detail.rate)
              }
              this.immediateOffer = this.immediateOffer + (detail.ratio * detail.stockNumber * detail.rate)
            }
          })
          if (type == 'init') {
            if ((createTime === 0 || budget.createTime > createTime) && data1 && data1 == 'refresh') {
              createTime = budget.createTime
              key = budget.id
              this.$refs.tripLeftDay.checkPlanDay = budget.day
            }
            var inquiryIds = [...new Set(budget.details.map(d => d.stockDetail.inquiryId))];
            this.$set(budget, 'totalPrice', totalPrice)
            this.$set(budget, 'saleTotalPrice', saleTotalPrice)
            this.$set(budget, 'inquiryId', inquiryIds.length > 0 ? inquiryIds.join(",") : '')
            this.$set(budget, 'currency', currency)
          }
        })
      })
      this.immediateCost = this.immediateCost.toFixed(2)
      this.immediateOffer = this.immediateOffer.toFixed(2)
      if (type == 'init') {
        if (data1 && data1 == 'refresh') {
          this.$nextTick(() => {
            document.getElementById('budget' + key).scrollIntoView()
            document.getElementById('planDay' + this.$refs.tripLeftDay.checkPlanDay).scrollIntoView()
          })
        }
      }
    },
    booking(value) {
      let budgetIds = []
      let arr = []
      this.chenckBudget.planDayList.forEach(item => {
        item.budgetDetails.forEach(detail => {
          arr.push(detail)
        })
      })


      let filteredArr = arr.filter(item => this.chooseStockTypes.includes(item.state) && !item.orderSize);
      if (filteredArr.length === 0) {
        this.$message({ type: "warning", message: "商品全部已定" })
        return
      }
      let filteredArr1 = filteredArr.filter(item => this.chooseStockTypes.includes(item.state) && item.totalPrice);
      if (filteredArr1.length === 0) {
        this.$message({ type: "warning", message: "成本金额是0,不需要下订单" })
        return
      }


      filteredArr1.forEach(detail => {
          console.log(detail, 'askdkaskdkasdksa');
        // if (detail.linkBudgetIds && detail.linkBudgetIds.length > 0) {
        //   budgetIds.push(...detail.linkBudgetIds)
        // } else {
        //   budgetIds.push(...detail.budgetIds)
        // }
        budgetIds.push(...detail.budgetDetailIds)
        budgetIds.push(-1)
      })
      console.log(budgetIds,value, '开始看的时刻打开时空的');

     this.$refs.orderPre.init(budgetIds, value)
    },
    openProductMoveDialog() {
      this.$refs.productMove.openDialog(this.chenckBudget)
    },
    changePlanTime() {
      this.$refs.changePlanTime.openBefore()
    },
  },
  props: {
    budgetList: {
      type: Array,
      default: () => { return [] }
    },
    chenckBudget: {
      type: Object,
      default: () => { return {} }
    },
    showCostPrice: {
      type: Boolean,
      default: true,
    },
    hasOrderNumber: {
      type: Boolean,
      default: false,
    },
    hasCustomerName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      chooseStockTypes: [],
      stockTypes: [],
      immediateCost: 0,
      immediateOffer: 0,
      planDetail: {},
      chenckBudgetIndex: 0,
      height: 0,
      planProductShowStatus: true,
      stockTypeList,
      searchProductName: '',
      oldPlanDays: [],
      orderStatus: '',
    }
  },
  mounted() {
    this.height = document.body.clientHeight - 159
  }
}
</script>

<style lang="scss" scoped>
.blueButton {
  color: rgb(64, 184, 255);
  font-size: 0.12rem;
  background: none;
  border-radius: 4px;
  border: 1px solid rgb(64, 184, 255);
  padding: 0.03rem 0.1rem;
  margin: 0.03rem 0 0.01rem 0.1rem;
}

.buttom {
  position: absolute;
  background-color: white;
  bottom: 0px;
  top: 1.6rem;
  width: 100%;

  .typeNav {
    border-bottom: 1px solid #EAEAEA;
    height: 0.6rem;
    display: flex;

    >div:first-child {
      width: 2.6rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    >div:last-child {
      display: flex;
      width: 7rem;
      justify-content: space-between;

      .typeList {
        display: flex;
        align-items: center;
        height: 100%;

        .checkedLi {
          background: #db4e1a;
          color: #fff;
          border-color: #db4e1a;
        }

        >div:first-child {
          width: 0.35rem;
          border-radius: 0;
        }

        >div {
          width: 0.28rem;
          height: 0.28rem;
          border-radius: 50%;
          border: 1px solid #dcdcdc;
          line-height: 0.25rem;
          text-align: center;
          cursor: pointer;
          margin-right: 0.05rem;
        }
      }

      .priceDiv {
        display: flex;
        height: 100%;
        align-items: center;
        padding-right: 5px;

        .checkedPrice {
          font-size: 0.16rem;

          b {
            font-size: 0.18rem;
          }
        }

        p:first-child {
          margin-bottom: 0.1rem;
        }

        p {
          font-size: 0.12rem;
        }

        b {
          color: #f54402;
          font-size: 0.14rem;
        }
      }

      .right {
        .top_title {
          color: #02A0C6;
          font-size: 0.12rem;
          text-align: center;
          margin-bottom: 0.04rem;
        }

        .right_item {
          display: flex;
          color: #747474;
          font-size: 0.12rem;
          margin-bottom: 0.03rem;
          white-space: nowrap;

          >div {
            margin-right: 0.1rem;
          }
        }
      }
    }
  }

  .planDayDiv {
    position: absolute;
    top: 0.7rem;
    bottom: 0;
    width: 100%;
    display: flex;

    .right {
      width: 6.98rem;
      overflow-y: scroll;
    }

    .right::-webkit-scrollbar {
      display: none;
    }

    .rightButton {
      position: absolute;
      right: 0.07rem;
      top: 40%;

      .circle {
        width: 0.15rem;
        box-shadow: 0px 0px 4px 0px #868686;
        border-radius: 50%;
        width: 0.2rem;
        height: 0.2rem;
        align-items: center;
        display: flex;
        justify-content: center;
        margin-bottom: 0.05rem;
        color: #e64a19;
      }
    }
  }
}
</style>
